var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotoV29Latin900(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "roboto-v29-latin-900_svg__Roboto",
    horizAdvX: 1206
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Roboto Black",
    unitsPerEm: 2048,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 1900,
    descent: -500,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 510
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 565,
    d: "M429 461H156l-43 995h359l-43-995zM103 151q0 74 53 121t134 48 133-47 54-122-53-121-134-48-133 47-54 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 649,
    d: "M255 1398l-43-429H25v568h230v-139zm351 0l-43-429H378v568h228v-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1190,
    d: "M612 410H451L384 0H185l67 410H30v183h252l44 264H105v183h251l69 416h198l-68-416h161l69 416h199l-69-416h231V857H885l-44-264h229V410H811L744 0H545l67 410zM481 593h161l44 264H525l-44-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1186,
    d: "M760 386q0 79-39 124t-137 85-181 81-143 95-92 125-32 172q0 169 114 278t304 128v211h159v-215q183-27 287-150t105-314H767q0 104-40 160t-114 56q-66 0-102-41t-37-115q0-74 42-117t135-83 175-82 143-97 94-126 34-173q0-171-108-279T693-17v-201H534v202Q316 7 200 133T83 467h337q0-114 50-173t144-60q68 0 107 40t39 112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1520,
    d: "M90 1176q0 135 88 218t236 83q150 0 237-82t87-224v-72q0-135-87-217t-235-82q-147 0-236 81t-90 224v71zm217-77q0-52 29-84t80-33q105 0 105 134v60q0 52-28 85t-79 34q-49 0-78-32t-29-89v-75zm475-742q0 136 88 218t236 82q149 0 237-81t88-226v-70q0-136-87-218t-236-82q-147 0-236 81t-90 224v72zm216-77q0-47 32-82t78-36q97 0 105 92l1 103q0 53-29 85t-79 33q-48 0-77-30t-31-83v-82zM480 109l-157 79 711 1138 157-79L480 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1380,
    d: "M311 767q-59 84-92 160t-34 157q0 176 114 284t298 109q165 0 273-100t108-250q0-186-205-330l-76-53 224-257q55 110 55 241h283q0-295-136-473L1345 0H969l-68 77Q817 27 730 3T532-21Q316-21 186 92T56 391q0 101 51 183t201 191l3 2zm243-528q88 0 168 41L460 578l-9-6q-57-70-57-158 0-73 46-124t114-51zm-78 849q0-70 76-170l67 42q46 30 67 62t21 81q0 46-32 80t-79 34q-56 0-88-35t-32-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 316,
    d: "M283 1374l-33-413H43v575h240v-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 723,
    d: "M120 592q0 244 65 454t179 356 255 204l64-166q-140-103-216-321t-78-513v-44q0-301 76-522t218-324l-64-166q-138 56-254 204T185 109t-65 438v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 721,
    d: "M626 564q0-235-69-446T367-244 104-450L40-284Q179-180 255 36t79 497v61q0 301-76 522T40 1440l64 166q140-55 260-203t190-357 72-438v-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 952,
    d: "M352 956l-326 90 65 189 319-131-25 352h214l-26-359 310 128 65-191-330-90 219-265-173-118-183 294-184-284-173 113 228 272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1094,
    d: "M702 826h341V537H702V146H387v391H45v289h342v380h315V826z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 552,
    d: "M213-392L43-312l34 68q70 130 73 248v250h270l-1-217q-1-115-59-234T213-392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 921,
    d: "M753 497H152v261h601V497z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 619,
    d: "M303 327q80 0 133-47t53-122-53-121-133-48q-81 0-133 48t-53 121 52 121 134 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 719,
    d: "M210-125H-29l497 1581h240L210-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1186,
    d: "M1100 595q0-295-132-455T594-20q-243 0-376 161T85 595v266q0 295 132 455t375 160 375-161 133-455V595zM763 904q0 157-41 234t-130 78q-87 0-126-72t-43-218V554q0-163 41-238t130-76q86 0 127 73t42 231v360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 1186,
    d: "M836 0H498v1076l-332-97v256l639 221h31V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1186,
    d: "M1105 0H89v220l468 492q173 197 173 313 0 94-41 143t-119 49q-77 0-125-65t-48-164H59q0 134 67 247t186 178 266 64q236 0 363-109t128-313q0-86-32-167t-99-171-218-240L532 260h573V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1186,
    d: "M397 869h159q189 0 189 185 0 72-45 117t-127 46q-67 0-116-39t-50-97H70q0 115 64 205t177 140 250 51q243 0 382-111t139-305q0-94-57-177T857 748q116-42 182-127t66-212q0-195-150-312T561-20q-143 0-265 54T110 185 47 405h339q0-67 54-116t133-49q89 0 142 49t53 127q0 110-55 156t-152 46H397v251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1186,
    d: "M979 569h148V309H979V0H642v309H79L59 515l583 938v3h337V569zm-599 0h262v448l-21-34-241-414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1186,
    d: "M109 712l89 744h851v-262H472l-33-289q36 21 94 37t115 16q217 0 333-128t117-361q0-140-62-253T860 41 593-20q-137 0-257 56T148 191 81 414h338q5-80 51-127t121-47q170 0 170 252 0 233-208 233-118 0-176-76l-268 63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1186,
    d: "M903 1477v-265h-15q-189 0-310-90T428 870q114 112 288 112 189 0 301-138t112-362q0-139-65-255T881 46 620-20q-155 0-277 70T153 252 83 554v135q0 225 96 404t276 282 397 102h51zM599 724q-67 0-112-31t-67-76V516q0-276 191-276 77 0 128 69t52 173q0 107-52 174t-140 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1186,
    d: "M1101 1276L557 0H201l545 1196H52v260h1049v-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1186,
    d: "M1071 1067q0-106-52-187T874 750q104-51 165-139t61-210q0-195-134-308T595-20Q358-20 221 93T84 401q0 117 60 207t170 142q-93 49-146 130t-53 187q0 190 129 300t348 110q221 0 350-110t129-300zM762 428q0 90-46 138t-123 49-123-48-47-139q0-87 47-137t125-51q75 0 121 50t46 138zm-170 789q-68 0-103-44t-36-124q0-78 36-126t106-48q69 0 103 48t35 126-35 123-106 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1186,
    d: "M753 563q-109-98-244-98-198 0-314 134T79 957q0 140 65 260t182 190 260 70q144 0 260-72t182-205 67-306V765q0-241-94-418T731 75 323-20h-21v270l64 1q348 17 387 312zM600 708q110 0 158 95v140q0 140-47 207t-127 67q-71 0-119-76t-48-184q0-114 49-181t134-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 615,
    d: "M304 327q80 0 133-47t53-122-53-121-133-48q-81 0-133 48t-53 121 52 121 134 48zm0 798q80 0 133-47t53-122-53-121-133-48q-81 0-133 48t-53 121 52 121 134 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 590,
    d: "M294 1125q80 0 133-47t53-122-53-121-133-48q-81 0-133 48t-53 121 52 121 134 48zM238-392L68-312l34 68q70 130 73 248v250h270l-1-217q-1-115-59-234T238-392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1044,
    d: "M383 609l547-184V118L46 478v266l884 360V798L383 609z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1199,
    d: "M1054 722H128v260h926V722zm0-439H128v260h926V283z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1050,
    d: "M655 612L111 797v306l879-360V477L111 117v306l544 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1043,
    d: "M344 461q0 146 33 230t107 147 112 113 39 114q0 151-130 151-60 0-97-44t-39-119H31q2 200 126 311t348 112q223 0 345-103t123-293q0-83-33-151T834 790L719 683q-49-47-68-96t-21-126H344zm-41-304q0 74 53 121t134 48 133-47 54-122-53-121-134-48-133 47-54 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1834,
    d: "M1756 550q-10-261-130-416T1306-21q-82 0-145 35t-98 101Q965-17 800-17q-96 0-168 56T527 200t-21 236q30 250 161 402t321 152q147 0 253-68l63-42-51-587q-17-139 96-139 85 0 142 108t64 278q17 334-138 516t-456 182q-191 0-339-97T387 865t-98-407Q273 108 429-77t468-186q84 0 178 19t153 46l37-166q-61-40-164-64t-208-25q-273 0-461 104T151-39 69 458q12 276 127 494t316 338 453 120 435-104 275-301 81-455zM756 436q-11-130 20-196t102-67q47 0 86 42t66 120l40 456q-30 8-62 8-112 0-172-87t-80-276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1321,
    d: "M110 0v1456h523q281 0 427-103t147-299q0-113-52-193t-153-118q114-30 175-112t61-200q0-214-135-321T701 0H110zm351 619V270h230q95 0 146 43t51 123q0 182-181 183H461zm0 230h183q115 1 164 42t49 121q0 92-53 132t-171 41H461V849z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1344,
    d: "M1288 493q-7-152-82-268T996 44 686-20q-287 0-452 187T69 695v72q0 214 74 374t215 248 324 88q265 0 426-139t183-385H941q-4 133-67 191t-192 58q-131 0-192-98t-64-313V688q0-233 58-333t202-100q121 0 185 57t68 181h349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1324,
    d: "M110 0v1456h469q193 0 347-87t240-247 88-358v-67q0-200-84-358T932 91 589 0H110zm351 1185V270h122q151 0 232 107t81 320v63q0 211-81 318t-236 107H461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1146,
    d: "M1013 617H461V270h652V0H110v1456h1005v-271H461V878h552V617z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1120,
    d: "M1027 580H461V0H110v1456h974v-271H461V850h566V580z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1396,
    d: "M1302 180q-81-90-237-145T723-20q-286 0-457 175T83 642l-1 126q0 215 76 375t217 247 328 87q272 0 422-124t176-372H963q-18 122-78 174t-170 52q-132 0-204-112t-73-320v-88q0-218 74-327t235-110q137 0 204 61v226H707v241h595V180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1439,
    d: "M1327 0H978v608H461V0H110v1456h351V878h517v578h349V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 618,
    d: "M484 0H134v1456h350V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1151,
    d: "M690 1456h350V457q0-139-64-248T796 40 538-20q-238 0-370 120T36 440h352q0-100 34-145t116-45q73 0 112 54t40 153v999z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1310,
    d: "M605 542L461 384V0H110v1456h351V814l122 185 314 457h434L839 812 1331 0H915L605 542z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1110,
    d: "M461 270h611V0H110v1456h351V270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1795,
    d: "M571 1456L896 443l324 1013h462V0h-352v340l34 696L1012 0H780L427 1037l34-697V0H110v1456h461z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1438,
    d: "M1326 0H977L461 906V0H110v1456h351l515-906v906h350V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1414,
    d: "M1343 698q0-213-79-377T1040 69 708-20 378 65 154 310 69 675v82q0 214 78 377t225 253 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-264 0-279-396l-1-107q0-214 71-329t211-115q133 0 205 113t73 325v67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1333,
    d: "M461 494V0H110v1456h581q167 0 295-61t199-175 71-258q0-213-152-340T685 494H461zm0 271h230q102 0 155 51t54 144q0 102-55 163t-150 62H461V765z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1414,
    d: "M1345 698q0-202-67-352t-185-242l235-186-217-184L798-14q-44-6-88-6-186 0-330 86T156 312 72 680v77q0 215 78 378t224 252 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-139 0-209-111t-71-325v-67q0-215 71-329t211-115q134 0 205 113t73 325v67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1336,
    d: "M651 514H461V0H110v1456h573q259 0 405-115t146-325q0-152-61-252T980 602l304-587V0H908L651 514zM461 785h222q100 0 150 52t51 147-51 147-150 54H461V785z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1282,
    d: "M861 387q0 77-54 120t-192 89-224 89q-283 139-283 382 0 121 70 213t200 144 290 52q157 0 281-56t194-159 69-237H862q0 89-54 138t-148 49q-94 0-148-41t-55-106q0-56 60-101t211-94 248-105q236-136 236-375 0-191-144-300T673-20q-177 0-320 63T137 217 64 472h352q0-117 60-172t197-56q87 0 137 37t51 106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1291,
    d: "M1253 1185H816V0H465v1185H36v271h1217v-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1361,
    d: "M1252 1456V503q0-162-69-280T985 42 680-20q-266 0-419 138T105 496v960h353V489q6-239 222-239 109 0 165 60t56 195v951h351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1353,
    d: "M675 396l290 1060h392L867 0H483L-3 1456h389L675 396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1780,
    d: "M1238 543l167 913h348L1444 0h-364L885 830 694 0H331L21 1456h349l167-913 200 913h298l203-913z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1307,
    d: "M653 972l238 484h401L885 734 1303 0H898L653 493 408 0H4l417 734-406 722h400l238-484z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1286,
    d: "M643 824l268 632h379L821 523V0H465v523L-3 1456h377l269-632z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1249,
    d: "M504 270h696V0H66v185l694 1000H62v271h1131v-180L504 270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 577,
    d: "M564 1460H446V-104h118v-245H108v2055h456v-246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 873,
    d: "M-20 1456h351L939-125H586L-20 1456z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 577,
    d: "M14 1706h456V-349H14v245h119v1564H14v246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 916,
    d: "M460 1182L289 729H36l299 727h249l300-727H630l-170 453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 904,
    d: "M903-251H0V0h903v-251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 695,
    d: "M610 1222H336L54 1536h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1153,
    d: "M1099 532q0-266-110-409T679-20q-165 0-266 131L399 0H97v1536h337V995q94 107 243 107 202 0 312-145t110-408v-17zm-338 21q0 156-41 222t-128 67q-114 0-158-87V325q43-86 160-86 119 0 151 116 16 57 16 198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1064,
    d: "M552 240q71 0 110 38t38 108h316q0-178-127-292T560-20q-236 0-372 148T52 538v14q0 164 60 289t175 193 270 68q211 0 335-117t124-317H700q0 84-41 129t-110 45q-131 0-153-167-7-53-7-146 0-163 39-226t124-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1152,
    d: "M52 549q0 257 111 405t310 148q145 0 244-114v548h338V0H752l-17 116Q631-20 471-20q-193 0-306 148T52 549zm337-21q0-288 168-288 112 0 160 94v412q-46 96-158 96-156 0-169-252l-1-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1115,
    d: "M618-20q-249 0-403 148T61 515v28q0 166 61 293t180 196 280 70q228 0 360-141t132-395V435H404q18-91 79-143t158-52q160 0 250 112l154-182Q982 83 867 32T618-20zm-38 862q-148 0-176-196h340v26q2 81-41 125t-123 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 742,
    d: "M169 0v848H12v234h157v86q0 185 109 287t306 102q72 0 158-21l1-248q-31 9-83 9-153 0-153-132v-83h211V848H507V0H169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1178,
    d: "M55 549q0 164 54 290t155 194 235 69q169 0 264-114l12 94h306V41q0-143-66-248T822-369t-292-57q-119 0-230 45T129-264L270-66q94-111 248-111 224 0 224 230v34Q645-20 497-20q-198 0-320 151T55 537v12zm338-21q0-133 50-210t140-78q109 0 159 73v455q-49 74-157 74-90 0-141-80t-51-234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1156,
    d: "M424 966q108 136 276 136 179 0 270-106t93-313V0H725v675q0 86-35 126t-119 41q-104 0-147-66V0H87v1536h337V966z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 563,
    d: "M450 0H112v1082h338V0zM92 1361q0 72 52 118t135 46 135-46 52-118-52-118-135-46-135 46-52 118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 553,
    d: "M457 1082V-37q-1-192-110-296T43-437q-84 0-159 17v255q58-9 95-9 140 0 140 139v1117h338zM94 1361q0 72 52 118t135 46 135-46 52-118-52-118-135-46-135 46-52 118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1120,
    d: "M529 403l-95-95V0H97v1537h337V721l34 45 254 316h404L747 637 1151 0H765L529 403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 563,
    d: "M450 0H112v1536h338V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1764,
    d: "M413 1082l11-127q115 147 309 147 205 0 277-163 110 163 318 163 329 0 338-398V0h-338v683q0 83-28 121t-102 38q-100 0-149-89l1-14V0H712v681q0 85-27 123t-103 38q-97 0-148-89V0H97v1082h316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1155,
    d: "M404 1082l11-127q112 147 309 147 169 0 252-101t87-304V0H725v683q0 82-33 120t-120 39q-99 0-147-78V0H88v1082h316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1150,
    d: "M52 551q0 162 63 288t181 195 277 68q243 0 383-150t140-410v-12q0-253-140-401T575-20q-231 0-371 138T53 494l-1 57zm337-21q0-150 47-220t139-70q180 0 184 277v34q0 291-186 291-169 0-183-251l-1-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1153,
    d: "M1099 533q0-252-113-402T679-20Q530-20 434 89v-505H97v1498h315l10-100q97 120 255 120 200 0 311-147t111-406v-16zm-337 21q0 288-168 288-120 0-160-86V330q44-90 162-90 161 0 166 278v36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1151,
    d: "M52 552q0 258 112 404t309 146q166 0 266-136l24 116h292V-416H717V90Q620-20 471-20q-192 0-305 148T52 552zm337-21q0-291 168-291 116 0 160 88v428q-42 86-158 86-157 0-169-251l-1-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 776,
    d: "M749 777l-111 8q-159 0-204-100V0H97v1082h316l11-139q85 159 237 159 54 0 94-12l-6-313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1049,
    d: "M661 304q0 43-45 69t-171 54-208 73-125 111-43 149q0 149 123 245t322 97q214 0 344-97t130-255H650q0 130-137 130-53 0-89-29t-36-74q0-45 44-73t140-46 170-43q244-84 244-301 0-148-131-241T514-20q-139 0-248 50T96 166 35 347h315q2-75 50-109t123-35q69 0 103 28t35 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 703,
    d: "M487 1351v-269h178V848H487V353q0-61 22-85t87-24q50 0 84 6V9q-91-29-190-29-174 0-257 82t-83 249v537H12v234h138v269h337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1155,
    d: "M739 117Q632-20 450-20 272-20 181 83T89 381v701h337V379q0-139 135-139 116 0 165 83v759h339V0H749l-10 117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1058,
    d: "M526 401l171 681h355L699 0H355L2 1082h356l168-681z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1487,
    d: "M1029 444l109 638h323L1206 0H921L742 642 562 0H277L22 1082h323l107-653 172 653h235l170-638z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1054,
    d: "M533 784l157 298h350L755 555 1054 0H702L532 320 365 0H11l300 555-284 527h354l152-298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1061,
    d: "M527 472l180 610h361L627-181l-19-46q-94-210-332-210-66 0-139 20v241h44q71 0 108 20t56 74l27 72L-4 1082h360l171-610z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1054,
    d: "M492 260h493V0H66v188l480 634H87v260h887V900L492 260z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 665,
    d: "M562-360Q202-259 202 105v198q0 202-162 202v227q162 0 162 203v210q3 180 93 291t267 161l63-176q-126-48-131-269V935q0-224-185-316 185-92 185-317V86q5-221 131-269l-63-177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 523,
    d: "M356-270H172v1726h184V-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 665,
    d: "M41-183q126 48 131 269v217q0 225 186 316-186 91-186 316v217q-5 221-131 269l63 176q179-50 269-163t91-298V935q0-203 162-203V505q-162 0-162-201V91q-7-352-360-451L41-183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1295,
    d: "M1197 799q0-196-91-314T863 367q-75 0-135 29T591 500t-142 76q-50 0-83-49t-34-122l-238 4q0 196 89 311t243 116q76 0 139-29t137-104 138-75q51 0 83 49t33 123l241-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 510
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA1",
    horizAdvX: 615,
    d: "M171 623h273l43-995H128l43 995zm326 310q0-74-53-121t-134-48-133 47-54 122 53 121 134 48 133-47 54-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA2",
    horizAdvX: 1209,
    d: "M598 240q71 0 110 38t38 108h316q0-156-97-262T710-11v-234H510v232Q317 15 208 158T98 534v18q0 224 109 369t303 174v223h200v-225q165-29 258-141t94-284H746q0 84-41 129t-110 45q-131 0-153-167-7-53-7-146 0-163 39-226t124-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA3",
    horizAdvX: 1229,
    d: "M621 561l5-112q0-114-59-179h608V0H106v270h103q57 15 60 103l1 53-5 135H103v261h154l-6 217q0 205 122 320t332 116q224 0 349-115t126-312H850q0 157-136 157-51 0-82-40t-31-126l9-217h307V561H621z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA4",
    horizAdvX: 1397,
    d: "M1061 107Q902-20 700-20q-203 0-361 126L210-26 69 118l135 137Q104 411 104 608q0 204 109 365L69 1120l141 144 142-145q155 115 348 115 194 0 349-117l144 148 142-145-148-151q107-159 107-361 0-193-98-349l139-141-142-145-132 134zM290 608q0-118 54-218t149-159 207-58q111 0 206 58t149 158 54 219q0 119-54 219T906 985t-206 57q-112 0-206-57T345 828t-55-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA5",
    horizAdvX: 1108,
    d: "M554 937l187 519h357L792 742h205V552H725V452h272V263H725V0H375v263H72v189h303v100H72v190h244L9 1456h358l187-519z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA6",
    horizAdvX: 524,
    d: "M119-270v795h292v-795H119zm292 968H119v758h292V698z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA7",
    horizAdvX: 1301,
    d: "M1196 500q0-177-155-268 138-103 138-293 0-177-141-276T648-437q-268 0-411 107T94-25h338q0-75 50-113t166-38q193 0 193 114 0 58-57 94t-237 86-270 104-137 129-46 177q0 176 157 270-141 106-141 292 0 174 145 280t389 106q250 0 391-112t141-313H839q0 75-51 120t-144 45q-95 0-145-33t-50-91q0-66 56-100t202-71 232-75 142-86 86-112 29-148zM597 652q-62 16-117 36-49-40-49-120 0-68 44-103t215-89l118-34q56 44 56 120 0 62-55 101t-212 89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA8",
    horizAdvX: 1013,
    d: "M95 1365q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA9",
    horizAdvX: 1608,
    d: "M1116 596q0-152-87-233t-248-81-254 106-95 287v113q0 174 95 280t254 107q163 0 249-82t87-232H961q0 96-46 137t-134 42q-92 0-142-67t-52-181V669q0-117 51-184t143-68q89 0 134 40t45 139h156zM207 729q0-165 74-308t212-229 302-87q164 0 300 86t212 229 75 309-75 308-212 228-300 86q-159 0-295-82t-215-226-78-314zm-122 0q0 202 93 375t259 272 358 100 357-99 259-273 94-375q0-204-95-377T1151 79 795-20Q602-20 438 80T179 353 85 729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAA",
    horizAdvX: 904,
    d: "M600 705q-10 27-17 68-77-82-201-82-118 0-183 61t-66 167q0 110 84 170t257 61h102v51q0 127-116 127-65 0-101-25t-37-74l-173 14q0 104 87 168t224 65q135 0 213-72t78-205V883q0-97 26-178H600zM425 835q40 0 82 18t69 44v136H470q-76-1-119-31t-43-79q0-88 117-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAB",
    horizAdvX: 1054,
    d: "M567 515l232-399H593L321 506v19l272 390h206L567 515zm157 0l232-399H750L478 506v19l272 390h206L724 515z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAC",
    horizAdvX: 1124,
    d: "M960 374H760v260H125v171h835V374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAD",
    horizAdvX: 921,
    d: "M753 497H152v261h601V497z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAE",
    horizAdvX: 1608,
    d: "M85 729q0 202 93 375t259 272 358 100 357-99 259-273 94-375q0-204-95-377T1151 79 795-20Q602-20 438 80T179 353 85 729zm122 0q0-165 74-308t212-229 302-87q164 0 300 86t212 229 75 309-75 308-212 228-300 86q-159 0-295-82t-215-226-78-314zm444-76V316H500v850h281q154 0 239-70t86-194q0-110-107-170 58-32 81-88t23-138 3-117 14-57v-16H965q-13 34-13 194 0 76-33 109t-110 34H651zm0 134h128q76 0 126 31t51 85q0 70-35 99t-129 31H651V787z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAF",
    horizAdvX: 1065,
    d: "M875 1285H181v173h694v-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB0",
    horizAdvX: 813,
    d: "M125 1195q0 117 83 199t198 82q112 0 193-82t82-199q0-116-80-196t-195-81q-116 0-198 80t-83 197zm281-124q53 0 87 36t34 88-34 90-87 38-89-37-37-91 37-88 89-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB1",
    horizAdvX: 1102,
    d: "M688 974h312V703H688V355H394v348H84v271h310v319h294V974zM979 1H101v264h878V1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB2",
    horizAdvX: 768,
    d: "M697 667H69v147l286 253q50 44 74 86t25 63q0 76-85 76-43 0-68-30t-25-73H51q0 118 85 198t222 81q154 0 237-65t83-187q0-75-42-137T448 910l-81-68h330V667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB3",
    horizAdvX: 768,
    d: "M277 1141h88q101 0 101 82 0 32-25 50t-71 19q-35 0-62-13t-27-38H57q0 102 85 164t221 63q154 0 240-61t87-166q0-120-138-169 154-41 154-183 0-104-94-168t-249-65q-145 0-233 69T41 908h227q0-29 29-52t82-24q56 0 78 25t23 56q0 85-109 86h-94v142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB4",
    horizAdvX: 691,
    d: "M287 1536h356l-278-314H90l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB5",
    horizAdvX: 1313,
    d: "M470 1082V450q1-107 36-157t127-50q128 0 181 91v748h337V0H834l-5 53q-89-74-210-74-85 0-149 34v-429H132v1498h338z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB6",
    horizAdvX: 1001,
    d: "M657 0v520h-80q-230 0-362 127T82 988q0 213 133 340t363 128h308V0H657z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB7",
    horizAdvX: 657,
    d: "M324 854q81 0 133-48t53-121-52-121-134-48q-80 0-133 47t-53 122 53 121 133 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB8",
    horizAdvX: 569,
    d: "M373 10l-10-61q150-28 150-173 0-116-99-182t-275-66l-7 186q88 0 88 77 0 38-31 53T86-136l31 146h256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB9",
    horizAdvX: 768,
    d: "M542 667H319v533l-176-36v167l380 122h19V667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBA",
    horizAdvX: 938,
    d: "M117 1121q0 160 95 257t251 98 251-97 96-263v-72q0-159-94-256t-251-98q-158 0-253 98t-95 261v72zm175-77q0-98 46-153t127-55q78 0 123 54t47 151v80q0 97-46 152t-126 55q-78 0-124-54t-47-157v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBB",
    horizAdvX: 1054,
    d: "M284 914l272-390v-19L284 115H77l232 399L77 914h207zm413 0l272-390v-19L697 115H490l232 399-232 400h207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBC",
    horizAdvX: 1452,
    d: "M512 664H289v533l-176-36v167l380 122h19V664zm-50-547l-157 79 711 1138 157-79L462 117zm826 218h79V157h-79V0h-225v157H730l-15 145 348 487h225V335zm-363 0h138v191l-16-23-122-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBD",
    horizAdvX: 1537,
    d: "M422 117l-157 79 711 1138 157-79L422 117zm66 555H265v533l-176-36v167l380 122h19V672zM1470 0H842v147l286 253q50 44 74 86t25 63q0 76-85 76-43 0-68-30t-25-73H824q0 118 85 198t222 81q154 0 237-65t83-187q0-75-42-137t-188-169l-81-68h330V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBE",
    horizAdvX: 1689,
    d: "M644 117l-157 79 711 1138 157-79L644 117zm842 218h79V157h-79V0h-225v157H928l-15 145 348 487h225V335zm-363 0h138v191l-16-23-122-168zm-802 806h88q101 0 101 82 0 32-25 50t-71 19q-35 0-62-13t-27-38H101q0 102 85 164t221 63q154 0 240-61t87-166q0-120-138-169 154-41 154-183 0-104-94-168t-249-65q-145 0-233 69T85 908h227q0-29 29-52t82-24q56 0 78 25t23 56q0 85-109 86h-94v142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBF",
    horizAdvX: 1043,
    d: "M703 630q0-150-30-230T570 258l-66-61q-93-90-93-186 0-71 33-103t87-33q67 0 104 42t40 121h339q-4-201-127-312T539-385q-223 0-344 103T73 11q0 83 38 156t130 160l85 78q77 66 86 153l5 72h286zM569 765q-80 0-133 47t-54 122 53 121 134 48q82 0 134-48t53-121-52-120-135-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC0",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505zm320 989H586l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC1",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505zm202 1303h356l-278-314H545l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC2",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505zm584 1022v-13H858l-159 136-159-136H280v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC3",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505zm545 1294q0-114-66-193t-165-80q-66 0-147 42t-131 42q-32 0-54-22t-23-68l-187 10q0 111 66 192t164 81q50 0 131-36t102-42 46-5q32 0 55 22t23 68l186-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC4",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505zM287 1675q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC5",
    horizAdvX: 1395,
    d: "M937 272H456L372 0H-3l534 1456h330L1399 0h-377l-85 272zM540 543h313l-157 505-156-505zm-63 1186q0 86 65 144t160 59q93 0 158-58t66-145q0-85-64-142t-160-57q-96 0-160 57t-65 142zm225-104q48 0 75 30t28 74-27 75-76 31q-49 0-76-31t-28-75 27-74 77-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC6",
    horizAdvX: 1926,
    d: "M1851 0H954l-14 329H558L406 0H16l735 1456h1039v-264h-549l13-316h455V612h-444l15-348h571V0zM683 599h246l-21 486-225-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC7",
    horizAdvX: 1344,
    d: "M1288 493q-7-152-82-268T996 44 686-20q-287 0-452 187T69 695v72q0 214 74 374t215 248 324 88q265 0 426-139t183-385H941q-4 133-67 191t-192 58q-131 0-192-98t-64-313V688q0-233 58-333t202-100q121 0 185 57t68 181h349zM818 10l-10-61q150-28 150-173 0-116-99-182t-275-66l-7 186q88 0 88 77 0 38-31 53t-103 20l31 146h256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC8",
    horizAdvX: 1146,
    d: "M1013 617H461V270h652V0H110v1456h1005v-271H461V878h552V617zm-209 915H530l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC9",
    horizAdvX: 1146,
    d: "M1013 617H461V270h652V0H110v1456h1005v-271H461V878h552V617zM686 1846h356l-278-314H489l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCA",
    horizAdvX: 1146,
    d: "M1013 617H461V270h652V0H110v1456h1005v-271H461V878h552V617zm55 948v-13H802l-159 136-159-136H224v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCB",
    horizAdvX: 1146,
    d: "M1013 617H461V270h652V0H110v1456h1005v-271H461V878h552V617zM231 1675q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCC",
    horizAdvX: 618,
    d: "M484 0H134v1456h350V0zm-14 1532H196l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCD",
    horizAdvX: 618,
    d: "M484 0H134v1456h350V0zM351 1846h356l-278-314H154l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCE",
    horizAdvX: 618,
    d: "M484 0H134v1456h350V0zm250 1565v-13H468l-159 136-159-136h-260v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCF",
    horizAdvX: 618,
    d: "M484 0H134v1456h350V0zm-587 1675q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD0",
    horizAdvX: 1354,
    d: "M140 0v635H-30v191h170v630h469q193 0 347-87t240-247 88-358v-67q0-200-84-358T962 91 619 0H140zm560 635H491V270h122q151 0 232 107t81 320v63q0 211-81 318t-236 107H491V826h209V635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD1",
    horizAdvX: 1438,
    d: "M1326 0H977L461 906V0H110v1456h351l515-906v906h350V0zm-214 1837q0-114-66-193t-165-80q-66 0-147 42t-131 42q-32 0-54-22t-23-68l-187 10q0 111 66 192t164 81q50 0 131-36t102-42 46-5q32 0 55 22t23 68l186-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD2",
    horizAdvX: 1414,
    d: "M1343 698q0-213-79-377T1040 69 708-20 378 65 154 310 69 675v82q0 214 78 377t225 253 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-264 0-279-396l-1-107q0-214 71-329t211-115q133 0 205 113t73 325v67zm-121 773H591l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD3",
    horizAdvX: 1414,
    d: "M1343 698q0-213-79-377T1040 69 708-20 378 65 154 310 69 675v82q0 214 78 377t225 253 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-264 0-279-396l-1-107q0-214 71-329t211-115q133 0 205 113t73 325v67zM747 1846h356l-278-314H550l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD4",
    horizAdvX: 1414,
    d: "M1343 698q0-213-79-377T1040 69 708-20 378 65 154 310 69 675v82q0 214 78 377t225 253 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-264 0-279-396l-1-107q0-214 71-329t211-115q133 0 205 113t73 325v67zm143 806v-13H863l-159 136-159-136H285v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD5",
    horizAdvX: 1414,
    d: "M1343 698q0-213-79-377T1040 69 708-20 378 65 154 310 69 675v82q0 214 78 377t225 253 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-264 0-279-396l-1-107q0-214 71-329t211-115q133 0 205 113t73 325v67zm104 1078q0-114-66-193t-165-80q-66 0-147 42t-131 42q-32 0-54-22t-23-68l-187 10q0 111 66 192t164 81q50 0 131-36t102-42 46-5q32 0 55 22t23 68l186-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD6",
    horizAdvX: 1414,
    d: "M1343 698q0-213-79-377T1040 69 708-20 378 65 154 310 69 675v82q0 214 78 377t225 253 334 89q185 0 330-88t225-250 82-373v-67zm-357 61q0 217-72 329t-208 113q-264 0-279-396l-1-107q0-214 71-329t211-115q133 0 205 113t73 325v67zm-694 916q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD7",
    horizAdvX: 1083,
    d: "M53 381l299 305L53 992l193 183 293-299 293 299 193-183-300-306 300-305-193-183-293 298-293-298L53 381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD8",
    horizAdvX: 1409,
    d: "M1354 698q0-213-79-377T1051 69 719-20q-162 0-292 65L346-95H139l141 245Q81 349 81 706v51q0 215 78 378t224 252 334 89q157 0 287-64l61 106h208l-121-211q202-200 202-558v-51zm-357 61q0 133-29 229L572 299q60-45 147-45 134 0 205 113t73 325v67zm-560-61q0-133 27-227l394 687q-60 43-141 43-139 0-209-111t-71-325v-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD9",
    horizAdvX: 1361,
    d: "M1252 1456V503q0-162-69-280T985 42 680-20q-266 0-419 138T105 496v960h353V489q6-239 222-239 109 0 165 60t56 195v951h351zm-417 76H561l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDA",
    horizAdvX: 1361,
    d: "M1252 1456V503q0-162-69-280T985 42 680-20q-266 0-419 138T105 496v960h353V489q6-239 222-239 109 0 165 60t56 195v951h351zm-535 390h356l-278-314H520l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDB",
    horizAdvX: 1361,
    d: "M1252 1456V503q0-162-69-280T985 42 680-20q-266 0-419 138T105 496v960h353V489q6-239 222-239 109 0 165 60t56 195v951h351zm-153 109v-13H833l-159 136-159-136H255v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDC",
    horizAdvX: 1361,
    d: "M1252 1456V503q0-162-69-280T985 42 680-20q-266 0-419 138T105 496v960h353V489q6-239 222-239 109 0 165 60t56 195v951h351zm-990 219q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDD",
    horizAdvX: 1286,
    d: "M643 824l268 632h379L821 523V0H465v523L-3 1456h377l269-632zm43 1022h356l-278-314H489l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDE",
    horizAdvX: 1266,
    d: "M455 1456v-258h205q171-1 296-58t192-161 66-241q0-209-148-333T660 278H455V0H116v1456h339zm0-518V538h198q103 0 162 52t60 146q0 95-59 148t-161 54H455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDF",
    horizAdvX: 1330,
    d: "M472 0H134v1099q0 221 133 341t381 121q196 0 319-104t123-276q0-107-47-183t-48-163q0-31 24-64t109-115q143-139 143-288 0-187-124-287T794-20q-75 0-150 13T526 31l59 253q85-44 211-44 60 0 99 32t40 93q0 41-25 77T805 547 692 679t-34 138q0 103 47 187t47 163q0 59-40 97t-101 38q-74 0-106-52t-33-156V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE0",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29zm202 1002H421l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE1",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29zm84 1316h356l-278-314H380l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE2",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29zm466 1035v-13H693l-159 136-159-136H115v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE3",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29zm427 1564q0-114-66-193t-165-80q-66 0-147 42t-131 42q-32 0-54-22t-23-68l-187 10q0 111 66 192t164 81q50 0 131-36t102-42 46-5q32 0 55 22t23 68l186-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE4",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29zM122 1365q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE5",
    horizAdvX: 1087,
    d: "M704 0q-18 33-32 97Q579-20 412-20q-153 0-260 92T45 305q0 176 130 266t378 90h104v57q0 149-129 149-120 0-120-118H71q0 157 133 255t341 98 327-101 123-277V245q2-149 46-228V0H704zM493 220q63 0 104 27t60 61v173h-98q-176 0-176-158 0-46 31-74t79-29zM312 1419q0 86 65 144t160 59q93 0 158-58t66-145q0-85-64-142t-160-57q-96 0-160 57t-65 142zm225-104q48 0 75 30t28 74-27 75-76 31q-49 0-76-31t-28-75 27-74 77-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE6",
    horizAdvX: 1730,
    d: "M1238-20q-240 0-380 134-66-66-164-100T484-20q-199 0-311 91T61 324q0 158 129 244t385 87h142v46q0 66-34 103t-99 38q-72 0-110-29t-38-73L99 759q0 151 134 247t355 96q202 0 319-91 126 93 320 91 212 0 335-133t123-360V435h-639q14-98 75-146t163-49q126 0 223 40l62 27 81-206q-67-52-181-86t-231-35zM548 212q89 0 169 63v176H578q-78-1-129-37t-51-94q0-108 150-108zm679 630q-82 0-125-48t-55-148h309v26q0 81-33 125t-96 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE7",
    horizAdvX: 1064,
    d: "M552 240q71 0 110 38t38 108h316q0-178-127-292T560-20q-236 0-372 148T52 538v14q0 164 60 289t175 193 270 68q211 0 335-117t124-317H700q0 84-41 129t-110 45q-131 0-153-167-7-53-7-146 0-163 39-226t124-63zM698 10l-10-61q150-28 150-173 0-116-99-182t-275-66l-7 186q88 0 88 77 0 38-31 53t-103 20l31 146h256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE8",
    horizAdvX: 1115,
    d: "M618-20q-249 0-403 148T61 515v28q0 166 61 293t180 196 280 70q228 0 360-141t132-395V435H404q18-91 79-143t158-52q160 0 250 112l154-182Q982 83 867 32T618-20zm-38 862q-148 0-176-196h340v26q2 81-41 125t-123 45zm114 381H420l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE9",
    horizAdvX: 1115,
    d: "M618-20q-249 0-403 148T61 515v28q0 166 61 293t180 196 280 70q228 0 360-141t132-395V435H404q18-91 79-143t158-52q160 0 250 112l154-182Q982 83 867 32T618-20zm-38 862q-148 0-176-196h340v26q2 81-41 125t-123 45zm-4 695h356l-278-314H379l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEA",
    horizAdvX: 1115,
    d: "M618-20q-249 0-403 148T61 515v28q0 166 61 293t180 196 280 70q228 0 360-141t132-395V435H404q18-91 79-143t158-52q160 0 250 112l154-182Q982 83 867 32T618-20zm-38 862q-148 0-176-196h340v26q2 81-41 125t-123 45zm378 414v-13H692l-159 136-159-136H114v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEB",
    horizAdvX: 1115,
    d: "M618-20q-249 0-403 148T61 515v28q0 166 61 293t180 196 280 70q228 0 360-141t132-395V435H404q18-91 79-143t158-52q160 0 250 112l154-182Q982 83 867 32T618-20zm-38 862q-148 0-176-196h340v26q2 81-41 125t-123 45zm-459 524q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEC",
    horizAdvX: 584,
    d: "M462 0H123v1082h339V0zm-7 1202H181l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xED",
    horizAdvX: 584,
    d: "M462 0H123v1082h339V0zM336 1772h356l-278-314H139l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEE",
    horizAdvX: 584,
    d: "M462 0H123v1082h339V0zm257 1235v-13H453l-159 136-159-136h-260v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEF",
    horizAdvX: 584,
    d: "M462 0H123v1082h339V0zm-580 1345q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF0",
    horizAdvX: 1165,
    d: "M862 1308q261-259 261-658v-57q0-177-70-318T858 57 581-20q-148 0-267 63T130 219 64 468q0 233 120 363t334 130q127 0 228-62-49 139-156 241l-178-110-78 118 136 84q-108 66-244 103l108 244q236-48 415-176l163 101 77-118-127-78zM585 240q94 0 147 82t53 235v97q-66 66-194 66-98 0-143-67t-46-185q0-102 50-165t133-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF1",
    horizAdvX: 1155,
    d: "M404 1082l11-127q112 147 309 147 169 0 252-101t87-304V0H725v683q0 82-33 120t-120 39q-99 0-147-78V0H88v1082h316zm559 702q0-114-66-193t-165-80q-66 0-147 42t-131 42q-32 0-54-22t-23-68l-187 10q0 111 66 192t164 81q50 0 131-36t102-42 46-5q32 0 55 22t23 68l186-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF2",
    horizAdvX: 1150,
    d: "M52 551q0 162 63 288t181 195 277 68q243 0 383-150t140-410v-12q0-253-140-401T575-20q-231 0-371 138T53 494l-1 57zm337-21q0-150 47-220t139-70q180 0 184 277v34q0 291-186 291-169 0-183-251l-1-61zm348 692H463l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF3",
    horizAdvX: 1150,
    d: "M52 551q0 162 63 288t181 195 277 68q243 0 383-150t140-410v-12q0-253-140-401T575-20q-231 0-371 138T53 494l-1 57zm337-21q0-150 47-220t139-70q180 0 184 277v34q0 291-186 291-169 0-183-251l-1-61zm230 1006h356l-278-314H422l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF4",
    horizAdvX: 1150,
    d: "M52 551q0 162 63 288t181 195 277 68q243 0 383-150t140-410v-12q0-253-140-401T575-20q-231 0-371 138T53 494l-1 57zm337-21q0-150 47-220t139-70q180 0 184 277v34q0 291-186 291-169 0-183-251l-1-61zm612 725v-13H735l-159 136-159-136H157v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF5",
    horizAdvX: 1150,
    d: "M52 551q0 162 63 288t181 195 277 68q243 0 383-150t140-410v-12q0-253-140-401T575-20q-231 0-371 138T53 494l-1 57zm337-21q0-150 47-220t139-70q180 0 184 277v34q0 291-186 291-169 0-183-251l-1-61zm573 1254q0-114-66-193t-165-80q-66 0-147 42t-131 42q-32 0-54-22t-23-68l-187 10q0 111 66 192t164 81q50 0 131-36t102-42 46-5q32 0 55 22t23 68l186-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF6",
    horizAdvX: 1150,
    d: "M52 551q0 162 63 288t181 195 277 68q243 0 383-150t140-410v-12q0-253-140-401T575-20q-231 0-371 138T53 494l-1 57zm337-21q0-150 47-220t139-70q180 0 184 277v34q0 291-186 291-169 0-183-251l-1-61zm-225 835q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF7",
    horizAdvX: 1166,
    d: "M1103 563H59v244h1044V563zm-709 523q0 71 51 117t135 47 135-46 51-118-51-117-135-47-135 46-51 118zm0-809q0 71 51 117t135 47 135-46 51-118-51-117-135-47-135 46-51 118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF8",
    horizAdvX: 1151,
    d: "M52 551q0 162 63 288t181 195 277 68q94 0 177-25l69 142h177l-103-212q203-148 203-477 0-253-140-401T575-20q-93 0-171 22l-71-147H156L260 70Q52 217 52 551zm337-21q0-96 18-157l224 460q-26 9-58 9-169 0-183-251l-1-61zm370 21q0 85-17 147L523 246q22-6 52-6 180 0 184 277v34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF9",
    horizAdvX: 1155,
    d: "M739 117Q632-20 450-20 272-20 181 83T89 381v701h337V379q0-139 135-139 116 0 165 83v759h339V0H749l-10 117zm-2 1105H463l-282 314h356l200-314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFA",
    horizAdvX: 1155,
    d: "M739 117Q632-20 450-20 272-20 181 83T89 381v701h337V379q0-139 135-139 116 0 165 83v759h339V0H749l-10 117zM619 1536h356l-278-314H422l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFB",
    horizAdvX: 1155,
    d: "M739 117Q632-20 450-20 272-20 181 83T89 381v701h337V379q0-139 135-139 116 0 165 83v759h339V0H749l-10 117zm262 1138v-13H735l-159 136-159-136H157v17l323 277h193l328-281z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFC",
    horizAdvX: 1155,
    d: "M739 117Q632-20 450-20 272-20 181 83T89 381v701h337V379q0-139 135-139 116 0 165 83v759h339V0H749l-10 117zM164 1365q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFD",
    horizAdvX: 1061,
    d: "M527 472l180 610h361L627-181l-19-46q-94-210-332-210-66 0-139 20v241h44q71 0 108 20t56 74l27 72L-4 1082h360l171-610zm44 1064h356l-278-314H374l197 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFE",
    horizAdvX: 1148,
    d: "M1096 533q0-251-112-402T677-20Q527-20 433 87v-503H95v1952h338V997q94 105 242 105 197 0 309-145t112-407v-17zm-337 21q0 288-168 288-116 0-158-84V327q43-87 160-87 161 0 166 276v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFF",
    horizAdvX: 1061,
    d: "M527 472l180 610h361L627-181l-19-46q-94-210-332-210-66 0-139 20v241h44q71 0 108 20t56 74l27 72L-4 1082h360l171-610zm-411 893q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94zm519 0q0 55 43 94t108 39 107-39 44-94-43-94-108-39-107 39-44 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2013",
    horizAdvX: 1266,
    d: "M1458 578H403v264h1055V578z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2014",
    horizAdvX: 1541,
    d: "M1493 578H87v264h1406V578z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2018",
    horizAdvX: 511,
    d: "M291 1576l148-80q-82-148-85-277v-177H108v165q1 91 54 195t129 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2019",
    horizAdvX: 497,
    d: "M214 1000l-148 80q83 144 85 282v174h246v-163q0-93-53-198t-130-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201A",
    horizAdvX: 556,
    d: "M231-310L83-230q72 125 74 280v199h258l-1-190q-1-91-54-195T231-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201C",
    horizAdvX: 875,
    d: "M298 1576l148-80q-82-148-85-277v-177H115v165q1 91 54 195t129 174zm351 0l148-80q-82-148-85-277v-177H466v165q1 91 54 195t129 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201D",
    horizAdvX: 881,
    d: "M228 1000l-148 80q83 144 85 282v174h246v-163q0-93-53-198t-130-175zm362 0l-148 80q83 144 85 282v174h246v-163q0-93-53-198t-130-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201E",
    horizAdvX: 876,
    d: "M242-330L83-250q72 134 74 299v220h258l-1-207q0-97-48-207T242-330zm351 0l-160 80q82 153 85 297v222h259l-1-213q-2-96-54-204T593-330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2022",
    horizAdvX: 757,
    d: "M134 763q0 107 70 174t182 67q115 0 184-65t71-171v-42q0-107-69-172t-184-66q-113 0-182 64t-72 169v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2039",
    horizAdvX: 650,
    d: "M354 515l232-399H380L108 506v19l272 390h206L354 515z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u203A",
    horizAdvX: 620,
    d: "M283 914l272-390v-19L283 115H76l232 399L76 914h207z"
  })))));
}
export default SvgRobotoV29Latin900;